import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import DrawerLayout from './drawer_layout';
import { searchForBookable } from './helpers';
import OptionCard from './option_card';

const OptionGroups = () => {
  const experience = useSelector((state) => state.experience);
  const { option_groups: optionGroups } = experience;
  const regularBookableOption = searchForBookable(optionGroups);

  // For regular experience, display booking form directly when it has 1 bookable option
  if (regularBookableOption.length === 1) {
    // When single option, get price from experience.product_price
    const {
      product_price_definition: priceDefinition,
      product_price: price,
      product_from_price: fromPrice,
    } = experience;
    const bookableOption = {
      ...regularBookableOption[0],
    };

    if (price) {
      bookableOption.price = `${fromPrice ? 'From ' : ''}$${price} ${
        priceDefinition || ''
      }`;
    }

    return (
      <Redirect
        to={{
          pathname: '/booking-form',
          state: {
            bookableOption,
            back: false,
          },
        }}
      />
    );
  }

  return (
    <DrawerLayout back={false} showProductName>
      {optionGroups.map((optionGroup, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>
          <h5 className="fw-bold">{optionGroup.title}</h5>
          {optionGroup.options.map((option) => (
            <OptionCard
              key={option.title}
              option={option}
              group={optionGroup}
            />
          ))}
        </div>
      ))}
    </DrawerLayout>
  );
};

export default OptionGroups;
